/**
 * 차량 검색 설정 모달 — 업종 · 기종(톤수) · 규격 · 전고 · 옵션을 골라 검색조건을 만든다.
 *
 * 기사관리(/adm/members)와 헤더 제스처 기사검색 모달($j.F.Admin.Member.SearchModal)이
 * **같은 모듈을 쓴다.** 예전에는 두 곳이 같은 마크업을 각자 문자열로 들고 있었고
 * (public/js/a-member-list.js · SearchModal.js), 한쪽만 고치면 조용히 갈렸다.
 *
 * 스타일은 `resources/sass/admin/components/_car-search.scss` (.car-search).
 * 색은 토큰만 쓴다 — 헤더 쪽은 다크모드가 켜진 화면 위에 뜬다.
 *
 * 사용:
 *   $j.F.Admin.Member.CarSearchModal.open({
 *       car:     {car_type, car_range, jungo, option},   // 이전 선택 복원 (선택)
 *       onApply: (data) => {...},   // {car_type, car_range, jungo, option}
 *       onClear: () => {...},       // '조건 해제'
 *       single:  true,              // (선택) 기종 한 개만 — 범위 종료칸·전고를 빼고 연다
 *   });
 *
 * `single` 은 **오더**를 찾는 화면용이다(작업사진 갤러리). 오더는 기종을 범위로 들고 있어
 * 찾는 쪽은 한 개를 대야 한다 (CarCodeService::orderRangeSearchSql). 전고도 오더엔 없다.
 * 주지 않으면 지금까지와 같다.
 */
export default class CarSearchModal {
    static MODAL_ID = 'car-search-modal';

    /** 칸 id — 모달은 한 번에 하나만 뜨므로 고정 id 로 둔다 */
    static IDS = {
        car_type: 'cs-cartype',
        depth1:   'cs-d1',
        depth11:  'cs-d11',   // 톤수 종료 (스카이·사다리 범위검색)
        depth2:   'cs-d2',
        depth22:  'cs-d22',   // 규격 종료 (사다리는 CarSelect 가 숨긴다)
        jungo:    'cs-jungo',
        option:   'cs-opt',
    };

    static open({ car = {}, onApply, onClear, single = false } = {}) {
        const I = single
            ? (({depth11, depth22, jungo, ...rest}) => rest)(this.IDS)   // CarSelect 는 idList 에 없는 칸을 건너뛴다
            : this.IDS;
        const range = (id) => single ? '' : `<span class="cs-range">~<select id="${id}"></select></span>`;

        // 라벨이 축을 구분한다 — 예전엔 <select> 마다 인라인 파스텔로 구분해서
        // 다크모드 위에서 그 칸들만 밝게 튀었다.
        $j.Ui.JBModal.html(this.MODAL_ID, `
        <div class="car-search">
            ${this.row('업종', `<select id="${I.car_type}"></select>`)}
            ${this.row('기종', `<select id="${I.depth1}"></select>${range(this.IDS.depth11)}`)}
            ${this.row('규격', `<select id="${I.depth2}"></select>${range(this.IDS.depth22)}`, '', 'depth2')}
            ${single ? '' : this.row('전고', `<select id="${I.jungo}"></select>`)}
            ${this.row('옵션', `<div id="${I.option}" class="car-search-opts"></div>`, 'flex:1')}
            <div class="car-search-foot">
                <button type="button" class="car-search-btn car-search-clear" id="cs-clear">조건 해제</button>
                <button type="button" class="car-search-btn car-search-apply" id="cs-apply">검색</button>
            </div>
        </div>`, '차량 검색 설정');

        $j.F.CarSelect.initialize({ idList: I, v: car });

        $('#cs-apply').off('click').on('click', () => {
            const s = $j.F.CarSelect;
            const data = {
                car_type:  s.getCarType(),
                car_range: s.getCarRange(),
                jungo:     s.getJungo(),
                option:    s.getOption(),
            };
            $j.Ui.JBModal.close(this.MODAL_ID);
            if (typeof onApply === 'function') onApply(data);
        });

        $('#cs-clear').off('click').on('click', () => {
            $j.Ui.JBModal.close(this.MODAL_ID);
            if (typeof onClear === 'function') onClear();
        });
    }

    /**
     * 라벨 + 컨트롤 한 줄.
     * @param slot CarSelect 가 이 줄을 통째로 감출 수 있게 하는 칸 이름 (예: 사다리의 '규격')
     */
    static row(label, ctl, style = '', slot = '') {
        return `<div class="car-search-row"${slot ? ` data-cs-row="${slot}"` : ''}>
                    <label class="car-search-lb">${label}</label>
                    <div class="car-search-ctl" style="${style}">${ctl}</div>
                </div>`;
    }

    /**
     * 선택 결과를 사람이 읽는 문구로. 검색조건 뱃지에 쓴다.
     * @returns {string} 예) '1T ~ 3.5T 16~34m 굴절'
     */
    static memo(data) {
        if (!data || !data.car_range) return '';
        let s = $j.F.Car.getCarRangeStr(data);
        if (data.option) s += ' ' + data.option;
        return s;
    }
}
